import(/* webpackMode: "eager" */ "/var/www/appagent/src/app/(landing)/contact/page.tsx");
